import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { LayoutModule } from "@angular/cdk/layout";
import { CdkStepperModule } from "@angular/cdk/stepper";
import { FlexLayoutModule } from "@angular/flex-layout";
import {
  MatBottomSheetModule,
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  MatListModule,
  MatSidenavModule,
  MatToolbarModule,
} from "@angular/material";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { FileUploadModule } from "ng2-file-upload";
import { AlertComponent } from "./_components";
import { BottomSheetItemDescriptionComponent } from "./_components/bottom-sheet-item-description/bottom-sheet-item-description.component";
import { ErrorInterceptor, JwtInterceptor } from "./_helpers";
import { CurrencyFormat, PercentFormat } from "./_services";
import { TruncatePipe } from "./_services/truncate";
import { ConfiguratorComponent } from "./configurator/configurator.component";
import { CustomStepperComponent } from "./custom-stepper/custom-stepper.component";
import { MainNavComponent } from "./main-nav/main-nav.component";
import { MaterialModule } from "./material";
import { MyModalComponent } from "./modals/my-modal/my-modal.component";
import { SafeHtmlPipe } from "./safe-html.pipe";
// import {StartService} from './_services/start.service';

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    MainNavComponent,
    TruncatePipe,
    ConfiguratorComponent,
    CurrencyFormat,
    PercentFormat,
    CustomStepperComponent,
    SafeHtmlPipe,
    MyModalComponent,
    BottomSheetItemDescriptionComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    CommonModule,
    FormsModule,
    MatBottomSheetModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatDialogModule,
    LoadingBarHttpClientModule,
    MaterialModule,
    FlexLayoutModule,
    FileUploadModule,
    CdkStepperModule,
  ],
  entryComponents: [MyModalComponent, BottomSheetItemDescriptionComponent],
  providers: [
    // StartService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    // fakeBackendProvider
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
